import { PencilIcon } from '@heroicons/react/24/solid';

const EditIcon = () => {
  return <PencilIcon className='h-5 w-5 text-neutralColor-light hover:text-neutralColor-normal cursor-pointer' />;
};

export default EditIcon;
